/* ============================================================
   CUSTOM-MOBILE-MENU.JS – Kachel-Menü für Mobile
   ============================================================

   WARUM document-level capture für den Hamburger-Intercept?
   ----------------------------------------------------------
   Der Browser schickt Events erst von window → document →
   body → ... → target (summary). In der Capture-Phase feuert
   ein Listener auf dem PARENT IMMER ZUERST, unabhängig davon
   wann er registriert wurde. Durch e.stopPropagation() in der
   document-Capture-Phase erreicht das Event die summary nie →
   header-drawer.js bekommt keinen Click → kein X-Icon-Bug.
   ============================================================ */

(function () {
  'use strict';

  var isOpen   = false;
  var currentSub = null;

  /* ── Hamburger abfangen: Document-Level Capture ───────────────
     Feuert vor ALLEN Listenern auf summary/details/header-drawer.
     stopPropagation() in Capture-Phase = Event erreicht summary nie.
  ──────────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var overlay   = document.getElementById('cmm-overlay');
    var hamburger = document.querySelector('.menu-drawer-container > summary');

    if (!overlay || !hamburger) return;
    if (e.target !== hamburger && !hamburger.contains(e.target)) return;

    e.preventDefault();
    e.stopPropagation();           /* Event geht nicht weiter zu summary */
    e.stopImmediatePropagation(); /* Keine weiteren document-Listener */

    openMenu();
  }, true /* capture-Phase */);

  /* ── Overlay öffnen ─────────────────────────────────────────── */
  function openMenu() {
    var overlay = document.getElementById('cmm-overlay');
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;
    resetToGrid(overlay);
    /* header-drawer.js schließen um .menu-open-Klasse zu entfernen.
       Der CSS-Fix (body.cmm-active) greift zusätzlich als Fallback. */
    var headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer && typeof headerDrawer.close === 'function') {
      headerDrawer.close();
    }
  }

  /* ── Overlay schließen ──────────────────────────────────────── */
  function closeMenu() {
    var overlay = document.getElementById('cmm-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    isOpen = false;
    resetToGrid(overlay);
  }

  /* ── Zurück zur Kachelübersicht ─────────────────────────────── */
  function resetToGrid(overlay) {
    var grid = document.getElementById('cmm-grid');
    if (grid) grid.style.display = '';
    (overlay || document).querySelectorAll('.cmm-submenu').forEach(function (s) {
      s.style.display = 'none';
    });
    currentSub = null;
  }

  /* ── Overlay-interne Buttons verdrahten ─────────────────────── */
  function initCMM() {
    var overlay = document.getElementById('cmm-overlay');

    /* body.cmm-active steuert den CSS-Fix für das Hamburger-Icon */
    if (overlay) {
      document.body.classList.add('cmm-active');
    } else {
      document.body.classList.remove('cmm-active');
      return;
    }

    /* Schließen-Button */
    var closeBtn = document.getElementById('cmm-close');
    if (closeBtn) closeBtn.onclick = closeMenu;

    /* Kacheln → Untermenü */
    overlay.querySelectorAll('[data-cmm-submenu]').forEach(function (tile) {
      tile.onclick = function () {
        var sub = document.getElementById('cmm-submenu-' + tile.dataset.cmmSubmenu);
        if (!sub) return;
        var grid = document.getElementById('cmm-grid');
        if (grid) grid.style.display = 'none';
        overlay.querySelectorAll('.cmm-submenu').forEach(function (s) { s.style.display = 'none'; });
        sub.style.display = 'flex';
        currentSub = sub;
      };
    });

    /* Zurück-Buttons */
    overlay.querySelectorAll('[data-cmm-back]').forEach(function (btn) {
      btn.onclick = function () { resetToGrid(overlay); };
    });
  }

  /* ── Escape-Taste ───────────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !isOpen) return;
    var overlay = document.getElementById('cmm-overlay');
    if (currentSub) resetToGrid(overlay);
    else closeMenu();
  });

  /* ── Init ───────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCMM);
  } else {
    initCMM();
  }

  document.addEventListener('shopify:section:load', function () {
    initCMM();
    if (isOpen) closeMenu(); /* Overlay zurücksetzen bei Theme-Editor-Reload */
  });

})();
